import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {checkFormValidity, handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import MDTypography from "../../components/MDTypography";
import dayjs from "dayjs";
import {DesktopDatePicker} from "@mui/x-date-pickers";

export default function ManageAccountStartDateModal(props) {

  const [context, setContext] = useContext(AppContext);
  const [account, setAccount] = useState(props?.account);
  const [membershipStartDate, setMembershipStartDate] = useState(props?.account?.membershipStartDate);

  useEffect(() => {
    if (props?.account) {
      setAccount(props?.account);
      setMembershipStartDate(props?.account?.membershipStartDate);
    }
  }, [props?.account]);

  const [formInvalid, setFormInvalid] = useState(false);

  useEffect(()=> {
    let _account = {...account};
    _account.membershipStartDate = membershipStartDate;
    setAccount(_account);
  }, [membershipStartDate]);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(account)
  });

  const handleClose = () => {
    props.handleClose();
  };


  const handleSave = (data) => {
    props.handleSave(data);
  };

  return (
    <Modal onHide={handleClose} size={'lg'} show={props.show}>
      <form
        onChange={(e) => setFormInvalid(!!!checkFormValidity(e))}
        onSubmit={handleSubmit(handleSave)} id={'memberForm'}>
        <Modal.Header closeButton>
          <Modal.Title>Manage Account Start Date</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              {account && <Container>
                <Row>
                  <Col className={'col'} sm={6} xs={12}>
                    <MDTypography variant={'h6'} className={'mb-2'}>{account?.accountType?.name}&nbsp;</MDTypography>
                  </Col>
                </Row>
                <Row>
                  <Col className={'col'} sm={6} xs={6}>
                    <div className="form-group">
                      <label htmlFor="startDate">Membership Start Date</label>
                      <div className={'input-group d-block modal-picker'}>
                        <DesktopDatePicker
                          slotProps={{
                            actionBar: {
                              actions: ['today'],
                            },
                          }}
                          minDate={dayjs()}
                          value={membershipStartDate ? dayjs(membershipStartDate) : null}
                          disabled={!account?.recurring && !account?.accountType?.timeBased}
                          onChange={(e) => {
                            setMembershipStartDate(e?.$d || null);
                          }}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>}
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={formInvalid || props.saving}>
            {props.saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}